import { injectable } from '@patsnap/tahiti-core/shared/inversify';

type SiteRegion = 'CN' | 'US' | 'EU';

export interface CopilotHelpService {
    helpElement: Element | HTMLIFrameElement | null
    siteRegion: SiteRegion
    initHelpEntry: (region: SiteRegion) => Promise<void>
    openHelpEntry: () => void
}

export const CopilotHelpService = Symbol('CopilotHelpService');

const TOTAL_TIME = 60000 * 3; // 定时器总时间
const INTERVAL_TIME = 5000; // 单次查找时间间隔
const MAX_COUNT = TOTAL_TIME / INTERVAL_TIME; // 最大查找次数

const HELP_WRAPPER_SELECTOR = {
    'CN': 'ps-cs-btn',
    'US': '#launcher',
}

@injectable()
export class CopilotHelpServiceImpl implements  CopilotHelpService {
    public helpElement: Element| HTMLIFrameElement | null = null
    public siteRegion: SiteRegion = 'CN'
    private styleElement: Node | null = null

    private hiddenHelpEle() {
        const style = document.createElement('style');
        style.type = 'text/css';
        style.innerHTML = `
            ps-cs-btn,
            #launcher {
                visibility: hidden;
            }
        `;
        document.head.appendChild(style);
        this.styleElement = style;
    }

    private getTriggerEle(){
        let triggerEle:ShadowRoot | Element | null = null;
        if (this.siteRegion === 'CN') {
            triggerEle = this.helpElement?.shadowRoot || null;
        } else {
            if (this.helpElement instanceof HTMLIFrameElement) {
                const iframe = this.helpElement?.contentDocument || this.helpElement?.contentWindow?.document;
                triggerEle = iframe?.querySelector('[data-testid="launcher"]') || null;
            }
        }
        return triggerEle;
    }

    initHelpEntry(region: SiteRegion) {
        this.siteRegion = region;
        this.hiddenHelpEle();
        return new Promise<void>((resolve, reject) => {
            let count = 0;
            const interval = setInterval(() => {
                count++;
                if (count > MAX_COUNT) {
                    clearInterval(interval);
                    this.styleElement && document.head.removeChild(this.styleElement);
                    reject();
                }
                const helpWrapper = document.querySelector(HELP_WRAPPER_SELECTOR[region]);
                if (helpWrapper) {
                    this.helpElement = helpWrapper;
                    clearInterval(interval);
                    resolve();
                }
            }, INTERVAL_TIME);
        });
    }

    openHelpEntry() {
        const clickEvent = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
        });

        const triggerEle = this.getTriggerEle();
        triggerEle?.dispatchEvent(clickEvent);
    }
}